export enum MenuSelectedListaNegraEnum {
  todos = "todos",
  permanentes = "permanentes",
}
export interface ActionMenuListaNegraSelected {
  payload: MenuSelectedListaNegraEnum;
}
